// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import MenuBaseItem from './MenuBaseItem';

/**
 * `MenuHeader` component.
 */
const MenuHeader = ({ baseClassName, className, children, ...props }) => (
    <MenuBaseItem className={classNames(baseClassName, className)} {...props}>
        {children}
    </MenuBaseItem>
);

MenuHeader.propTypes = {
    /**
     * Content of the `MenuHeader`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

MenuHeader.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}menu__header`,
};

export default MenuHeader;



// WEBPACK FOOTER //
// ./components/Menu/MenuHeader.js